import { useEffect } from 'react';
import { Form, Input, Button} from 'antd';

const CategoryCareerForm = ({ initialValues, onSuccess, editMode }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (editMode && initialValues) {
            form.setFieldsValue(initialValues);
        } else {
            form.resetFields();
        }
    }, [editMode, initialValues, form]);

    const handleFinish = async (values) => {
        await onSuccess(values);
        form.resetFields();
    };

    return (
        <Form 
            form={form}
            layout='vertical'
            onFinish={handleFinish}
        >
            <Form.Item
                label="Name"
                name="name"
            >
                <Input placeholder='Masukkan Nama' />
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
                <Button
                    htmlType='submit'
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                >
                   {editMode ? "Update" : "Add"}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default CategoryCareerForm;